export default __webpack_public_path__ + "static/media/Subaru-logo-vertical-white.0dceea7e.png";